module.exports = __webpack_public_path__ + "img/Extrudechaud_Hoesch.0dc34064.jpg";